module.exports = __webpack_public_path__ + "img/smart8.467fdf58.png";